module.exports = {
    // basic
    'subscription': 'subscription',
    'width': 'width',
    'only-show-active-rigs': 'only show active rigs',
    'sub-assets': 'sub assets',
    'sort-order': 'sort order',
    'custom': 'custom',
    'direction': 'direction',
    'sort-by': 'sort by',
    'sort': 'sort',
    'sorting': 'sorting',
    'a-field-to-sort-by': 'a field to sort by',
    'publish': 'publish',
    'file-type': 'file type',
    'days-of-the-month': 'days of the month',
    'days-of-the-week': 'days of the week',
    'days-of-report-delivery': 'days of report delivery',
    'time': 'time',
    'time-of-report-delivery': 'time of report delivery',
    'scheduled': 'scheduled',
    'delivery': 'delivery',
    'font-size': 'font size',
    'compressed': 'compressed',
    'table-headers': 'table headers',
    'rich': 'rich',
    'format': 'format',
    'beneath': 'beneath',
    'beside': 'beside',
    'layout': 'layout',
    'report-format': 'report format',
    'set-range': 'set range',
    'date-range': 'range',
    'recurring-range': 'recurring range',
    'days-on-report': 'days on report',
    'newest-version-only': 'newest version only',
    'contents': 'contents',
    'report-company': 'report company',
    'report-type': 'report type',
    'details': 'details',
    'subscribe': 'subscribe',
    'unsubscribe': 'unsubscribe',
    'summary': 'summary',
    'report-summary': 'report summary',
    'subscribers': 'subscribers',
    'subscribed': 'subscribed',
    'report-name': 'report name',
    'report-title': 'report title',
    'report-file-name': 'report file name',
    'append-run-time-to-file-name': 'append run time to file name',
    'group-by': 'group by',
    'time-span': 'time span',
    'days-previous': 'days previous',
    'hours-previous': 'hours previous',
    'wells-with-all-entry-types': 'only wells containing all entry types',
    'include-soft-rejected': 'Include Soft Rejected',
    'include-link-to-entry': 'Include Link To Entry',
    'total-file-count': 'total file count',
    'total-file-size': 'total file size',
    'sort': 'sort',
    'run': 'run',
    'today-only': 'today only',
    'hours-back': 'hours back',
    'latest-per-rig': 'latest per rig',
    'send-mail-when-no-data': 'send mail when no data',
    // raw
    'day-required': 'Please select at least one day.',
    'time-required': 'Please select a time.',
    'end-date-required': 'Please enter end date.',
    'start-date-required': 'Please enter start date.',
    'report-schedule-invalid': 'Cannot disable schedule while Publish is on.',
    'report-title-required': 'Please enter a report title.',
    'report-type-required': 'Please select a report type.',
    'report-name-required': 'Please enter a report name.',
    'report-well-properties-edit-help': 'Columns specified here will be displayed after the default columns, in the order specified.',
    'report-publish-on-help': 'This report is visible to all authorized users, on the All Reports page. This report will be available for other authorized users to subscribe to.',
    'report-publish-off-help': 'This report is only visible to you, on the Reports I Created page. This report will not be available for other users to subscribe to.',
    'report-scheduled-on-help': 'The report will run, and be delivered to subscribers, on the schedule specified below.',
    'report-headers-compressed-help': 'Report content will appear in a single table, with a single header row at the top.',
    'report-headers-standard-help': 'Report content will appear in a multiple tables, with a header row at the top of each. ',
    'report-remarks-format-rich-help': 'Remarks will retain all formatting.',
    'report-remarks-format-standard-help': 'Remarks will not include any formatting.',
    'report-remarks-layout-beneath-help': 'Remarks will appear on its own row, directly beneath all other data.',
    'report-remarks-layout-beside-help': 'Remarks will appear in the last column, on the same row as all other data.',
    'report-date-range-help': 'Select the date range for the data on the report.',
    'report-subscribe-column-help': `
        If you subscribe to a report, you will receive it at regular intervals, based on its schedule.  If the button is disabled, it means the report has no schedule defined.
    `,
    'report-match-all-entry-types-help': `Entries included in the report will only come from wells that contain at least one entry for all entry types specified in the report criteria (regardless of which entries are included in the report).`,
    'report-match-any-entry-types-help': `Entries included in the report can come from wells that don't contain all entry types specified in the report criteria.`,
    'report-time-span-help': `<b>Date Ranges</b> controls set the range of data included in the output.`,
    'set-range-help': `Leave <b>End</b> empty to include everything from <b>Start</b> to the present (the time the report is run).`,
    'report-delete-confirm': `Are you sure you want to delete this report?`,
    'file-format-required': `Please select at least one format.`,
    'report-validation-failed': `One or more required fields are missing or incorrect. Please review the page and make corrections where indicated.`,
    'combined-pdf-report-rig-help':
        `<b>Rigs</b> controls which reports are included in the combined PDF, as well as the order in which they appear.<br />  
        Reports are combined in the select rig order, then by the name of the well.  <br />
        If no rigs are selected, all rigs are included.  `,
    'send-mail-when-no-data-no': `If the report is empty, given the selected criteria, no email will be sent. `,
    'send-mail-when-no-data-yes': `If the report is empty, given the selected criteria, an email will still be sent to all subscribers.<br /> No attachment will be included.`,
    'report-show-single': `This list is currently filtered to show a single report.`,
    'report-is-empty': 'Report is empty.',
    // template
    'report-doc-approval-well-properties-help': (words) => `
        <b>${words[0]}</b> controls what other columns (containing metadata about the well of that entry) appear with each entry.
    `,
    'report-doc-approval-well-limit-help': (words) => `
        <b>${words[0]}</b> allows you to limit the entries to a specific well.
    `,
    'report-doc-approval-status-help': (words) => `
        <p>
            <b>${words[0]}</b> filters results depending on an entry's overall approval status.
        </p>
        <p>
            Select <b>${words[1]}</b> to further filter results to entries pending approval for specific steps.
        </p>
    `,
    'report-doc-approval-template-help': (words) => `
        <b>${words[0]}</b> allows you to start by setting the <b>${words[1]}</b> to criteria stored in a template.  You can then modify the criteria for the report.
    `,
    'report-company-help': (words) => `<b>${words[0]}</b> essentially selects the company of the intended recipients. Only users having a role from this company will be able to see and subscribe to this report.`,
    'well-properties-for': (words) => `Columns for "${words[0]}"`,
    'sorting-for': (words) => `Sorting for "${words[0]}"`,
    'report-file-type-help': (words) => `<b>${words[0]}</b> controls which file types are included when the report is sent to recipients, or when you click <b>${words[1]}</b>.`,
    'report-scheduled-off-help': (words) => `The report will only run when either the <b>${words[0]}</b> or <b>${words[1]}</b> button is clicked. It will not be delivered to any current subscribers.`,
    'report-well-properties-help': (words) => `<b>${words[0]}</b>  allows selecting additional columns to include in the report. <b>${words[1]}</b> and <b>${words[2]}</b> columns will be included by default.  `,
    'report-sorting-help': (words) => `<b>${words[0]}</b> controls how this entry type is sorted on the report.`,
    'newest-version-only-help': (words) => `<b>${words[0]}</b> will only include the most recent entry from the selected entry type for any given date.`,
    'report-tab-asset-help': (words) => `<b>${words[0]}</b> can restrict the available entry types to those available on wells within a particular ${words[0].toLowerCase()}.`,
    'report-tab-well-group-help': (words) => `<b>${words[0]}</b> can restrict the available entry types to those available on wells within a particular ${words[0].toLowerCase()}.`,
    'report-tab-company-help': (words) => `<b>${words[0]}</b> selects the company whose data you want to include on the report.  All <b>${words[1]}</b> dropdowns, below, are reset whenever this selection changes.`,
    'report-type-help': (words) => `<b>${words[0]}</b> affects the type of data you can include on the report, possibly also changing the criteria selection in the <b>${words[1]}</b> area, below.`,
    'report-filename-help': (words) => `<b>${words[0]}</b> is the file name used whenever this report is delivered or downloaded.`,
    'report-title-help': (words) => `
    <b>${words[0]}</b> is the name that is visible in the report list to other users if the report is published.  <br />
    For some reports, it also appears at the top of the report file whenever it is generated.  <br />
    It also be used for the subject of the email used to deliver this report, if it is scheduled.  
    `,
    'report-name-help': (words) => `<b>${words[0]}</b> is the name that will appear in the ${words[1]} list for this report, and is only visible to you.`,
    'all-reports-company-filter': (words) => `<b>${words[0]}</b> filters reports to only published reports that include entry types from the selected company.`,

};
